import * as  React from 'react';
import {PaginationDefaultParams} from "../components/custom/Paginator";
import {RequestData} from '../models/axios';
import debounce from 'lodash/debounce';
import videoApi from "../api/video-file";

interface SelectionProps {
  count: number;
  data: any[];
  fetchRequest: (requestData: RequestData) => any;
  fetchItemsPickerDataSuccess: (requestData: RequestData) => any;
  location: object;
  type: string;
}

const videoFileFetcherHoc = <P extends object>(Component: React.ComponentType<P>) =>
  class Selection extends React.Component<P> {
    
    constructor(props) {
      super(props);
      this.fetchData = debounce(this.fetchData, 800);
    }
    
    state = {
      currentPage: 1,
      data: [],
      count: 0
    };
    
    filter = {};
    
    paginationParams = PaginationDefaultParams;
    
    isFetched = false;
    
    fetchData = (params: object = {}) => {
      videoApi.getList({
          params: {
            ...this.paginationParams,
            ...this.filter,
            ...this.props.filter || {}
          }
        })
        .then((response) => this.onFetchData(response))
        .catch(() => {
        
        })
    };
    
    onFetchData = ({data, meta}) => {
      this.setState({
        data: this.paginationParams.offset == 0 ? data : [...this.state.data, ...data],
        count: meta.total_count
      })
    };
    
    resetPagination = () => {
      this.paginationParams = PaginationDefaultParams;
    };
    
    handleSearch = query => {
      this.filter = {
        query
      };
      this.resetPagination();
      this.fetchData();
    };
    
    handleChange = value => {
      this.setState({
        value,
      });
    };
    
    onScroll = e => {
      e.persist();
      const {data, count} = this.state;
      let target = e.target;
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        if (count > data.length) {
          const offset = this.paginationParams.offset + PaginationDefaultParams.count;
          this.paginationParams = {
            offset: offset,
            count: PaginationDefaultParams.count
          };
          this.fetchData()
        }
      }
    };
    
    render() {
      return (
        <Component  {...this.props as P}
                    handleSearch={this.handleSearch}
                    handleChange={this.handleChange}
                    onScroll={this.onScroll}
                    data={this.state.data}
                    count={this.state.count}
                    isFetched={this.isFetched}
                    fetchData={this.fetchData}/>
      )
    }
  };

export default videoFileFetcherHoc;